module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DataTablePage', {
    ref: "historyTable",
    attrs: {
      "mainColumn": "",
      "longColumn": "",
      "title": "用水历史",
      "label": "用水",
      "labelName": "",
      "resource": _vm.resource,
      "toolbar": _vm.toolbar,
      "operation": _vm.operation,
      "operationWidth": 195,
      "updateList": _vm.updateList,
      "tableFullList": _vm.tableFullList,
      "tableInitList": _vm.tableInitList,
      "filterFullList": _vm.filterFullList,
      "filterInitList": _vm.filterInitList,
      "columns": _vm.columns
    },
    on: {
      "getData": _vm.getCountInitStatus,
      "checkGroupValue": _vm.checkGroupValue
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29a2af5a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/TelnetReading/WaterList.vue
// module id = 1725
// module chunks = 1